<template>
	<div class="userMain">
		<div class="tip">
			{{ siteConfigTips && siteConfigTips.tips_user_dashboard ? siteConfigTips.tips_user_dashboard : '--' }}
		</div>
		<!-- DESKTOP -->
		<div v-if="!isMobile" class="user-main-desktop">
			<div class="card-dashboard">
				<!-- <div @click="goToPage('user-manage', 'All')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('Classifieds') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.all_listing : 0 }}
					</div>
					<div class="icon-card">
						<LightListIcon />
					</div>
				</div> -->
				<!-- <div @click="goToPage('property', 'All')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('Property') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.all_listing_property : 0 }}
					</div>
					<div class="icon-card">
						<IconHomeOutline style="width:80px; height:80px;stroke-width: 0.5;"/>
					</div>
				</div> -->
				<div @click="goToPage('user-manage', 'All')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('userDashboard.control.allOfMe') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.all_listing : 0 }}
					</div>
					<div class="icon-card">
						<LightListIcon />
					</div>
				</div>
				<div @click="goToPage('user-manage', 'ExpiringSoon')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('userDashboard.control.expiringSoon') }}
					</div>
					<div class="amount">
						{{
							dataUserDashboard ? dataUserDashboard.listing_expiring_soon : 0
						}}
					</div>
					<div class="icon-card">
						<LightClockIcon />
					</div>
				</div>
				<div @click="goToPage('user-manage', 'Rejected')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('userDashboard.control.notValidated') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.listing_rejected : 0 }}
					</div>
					<div class="icon-card repeat-icon">
						<RepeatIcon />
					</div>
				</div>
				<div @click="goToPage('user-manage', 'Expired')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('userDashboard.control.expired') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.listing_expired : 0 }}
					</div>
					<div class="icon-card">
						<LightClockIcon />
					</div>
				</div>
				<div @click="goToPage('user-manage', 'Favorite')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('listing.title') }}
						<br />
						{{ $t('userDashboard.control.myFavorite') }}
					</div>
					<div class="amount">
						{{ dataUserDashboard ? dataUserDashboard.favorite : 0 }}
					</div>
					<div class="icon-card">
						<LightHeartIcon />
					</div>
				</div>
				<div @click="goToPage('message')" class="card-item">
					<div class="dashboard-title-card">
						{{ $t('userDashboard.control.messages') }}
						<br />
						{{ $t('userDashboard.control.mine') }}
					</div>
					<div class="amount">
						{{ unreadMessages ? unreadMessages : 0 }}
					</div>
					<div class="icon-card">
						<LightMessageIcon />
					</div>
				</div>
			</div>
		</div>
		<!-- MOBILE -->
		<div v-else class="user-main-mobile">
			<div class="wrap-navigate-mobile">
				<div class="navigate-item">
					<div
						@click="$router.push($i18nRoute({ name: '' }))"
						class="text-center"
					>
						<HomeOutlineIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.mobile.home') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('user-profile')" class="text-center">
						<UserIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.mobile.profile') }}
						</div>
					</div>
				</div>
				
				<div class="navigate-item">
					<div
						@click="goToPage('message')"
						class="position-relative text-center"
					>
						<div class="notification-number">
							{{ unreadMessages ? unreadMessages : 0 }}
						</div>
						<MessageOutlineIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.messages') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('user-manage')" class="text-center">
						<LightListIcon style="stroke: var(--projectPrimaryColor); stroke-width: 2px;"/>
						<div class="text">
							{{ $t('userDashboard.navigation.mylisting') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('user-manage','Favorite')" class="text-center">
						<FavoriteOutlineIcon />
						<div class="text">
							{{ $t('userDashboard.userManage.favListing') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div
						@click="goToPage('user-payment')"
						class="position-relative text-center"
					>
						<div class="payment-error">
							<AlertCircleIcon />
						</div>
						<CreditCardOutlineIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.payment') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('coins')" class="text-center">
						<div class="menu-icon">
							<IconCoin style="width:20px"/>
						</div>
						<div class="text">
							{{ $t('userDashboard.navigation.khaosodCoin') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('user-contact')" class="text-center" style="margin-top: 30px;">
						<EmailIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.contactAndReport') }}
						</div>
					</div>
				</div>
				<div v-if="isAdmin" class="navigate-item">
					<div @click="goToPage('admin-dashboard')" class="text-center">
						<ViewDashboardIcon />
						<div class="text">
							{{ $t('home.admin') }}
						</div>
					</div>
				</div>
			</div>
			<div class="logout" @click="userLogout">
				<LogoutIcon />
				{{ $t('userDashboard.navigation.logout') }}
			</div>
		</div>
	</div>
</template>

<script>
// Icons
import LightListIcon from '@/components/icons/IconLightList';
import LightClockIcon from '@/components/icons/IconLightClock';
import RepeatIcon from '@/components/icons/IconRepeat';
import LightHeartIcon from '@/components/icons/IconLightHeart';
import LightMessageIcon from '@/components/icons/IconLightMessage';
import HomeOutlineIcon from '@/components/icons/IconHomeOutline';
import UserIcon from '@/components/icons/IconUser';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import LogoutIcon from '@/components/icons/IconLogout/index';
import AlertCircleIcon from '@/components/icons/IconAlertCircle/index';
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import IconCoin from '@/components/icons/IconCoin/index';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import FavoriteOutlineIcon from 'vue-material-design-icons/HeartOutline.vue';
// import IconHomeOutline from "@/components/icons/IconHomeOutline/index";

export default {
	components: {
		LightListIcon,
		LightClockIcon,
		RepeatIcon,
		LightHeartIcon,
		LightMessageIcon,
		HomeOutlineIcon,
		UserIcon,
		MessageOutlineIcon,
		CreditCardOutlineIcon,
		EmailIcon,
		LogoutIcon,
		AlertCircleIcon,
		ViewDashboardIcon,
		IconCoin,
		FavoriteOutlineIcon,
		// IconHomeOutline
	},
	data() {
		return {
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false,
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null
		};
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('UserDashboardController', ['dataUserDashboard']),
		...mapState('SiteConfigController', ['siteConfigTips']),
		...mapGetters('ChatController', ['unreadMessages']),
	},
	watch: {
		modalTip: function(val) {
			if (val && this.siteConfigTips && this.siteConfigTips.tips_user_dashboard) {
				this.tip = Object.assign(this.tip, this.siteConfigTips.tips_user_dashboard);
			}
		}
	},
	created() {
		this.GET_SITE_TIPS();
	},
	methods: {
		...mapActions('SiteConfigController', ['GET_SITE_TIPS']),
		
		goToPage(page, tab = null) {
			if(page==='property'){
				window.open('https://property.khaosod.co.th/th/user-manage#All','_self')
			}else {
					if (tab) {
				this.$router.push(`${this.$i18nRoute({ name: 'user-manage' })}#${tab}`);
			
				
					
				}else{
					this.$router.push(this.$i18nRoute({ name: page }));
				}
			}
		},
		userLogout() {
			this.$root.signOut();
		}
	},
	mounted(){
		let _this=this;
		this.$store.dispatch('UserDashboardController/GET_DATA_USER_DASHBOARD');
		
		
		
	},

};
</script>
<style lang="scss">
@import 'userMain.scss';
</style>
